import React, { useState, useEffect, useRef } from 'react';
import { MenuItem } from "@mui/material";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import DocumentNavigation from './DocumentNavigation';
import { QRCodeSVG } from 'qrcode.react';


import { Paper,
  Typography,
  TextField,
  Button,
  Grid,
} from '@mui/material';
import bill from '../assets/bill.jpg';
import logo from '../assets/log.png';
import stamp from '../assets/stamp.jpg';
import { printWhenReady } from './printUtils';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { Buffer } from 'buffer';
import API_BASE_URL from '../api';
const InvoiceGenerator = () => {
  const DEMOUNIT_INVOICE_START = 26001;
  const [invoiceNumber, setInvoiceNumber] = useState(DEMOUNIT_INVOICE_START);
  const [loading, setLoading] = useState(true);
  const invoiceQrRef = useRef(null);
 
    const [clientDetails, setClientDetails] = useState({
      clientName: '',
      clientAddress: '',
      clientDistrict: '',
      clientPostalCode: '',
      clientCountry: '',
      clientAddNo: '',
      clientVatNumber: '',
      clientCRN: '',
      words:'',
    });
  
    const [invoiceDetails, setInvoiceDetails] = useState({
      invoiceDate: '',
      supplyDate: '',
      contractNo: '',
      invoicePeriod: '',
      projectRefNo: '',
    });
    const generateRandomNo = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
    const ourDetailsDefaults = {
      name: 'LAR Contracting Company',
      shortAddress: 'ENAA8599',
      secondaryNo: '2287',
      addlNo: '31335115107',
      buildingNo: '8599',
      city: 'Prince Saud Ibn Abdullah Ibn Jalawi Branch, Al Jubail',
      district: 'Tebah Dist.',
      country: 'Kingdom of Saudi Arabia',
      postalCode: '35513',
      vatNumber: '314702232800003',
      crn: '7053932963',
    };
    const [ourDetails] = useState(ourDetailsDefaults);
    const [products, setProducts] = useState([
      {
      
        unitRate: '',
        quantity: '',
        vatRate: '15.00',
        totalExclVAT: 0,
        vatAmount: 0,
        totalInclVAT: 0,
        translatedNatureOfGoods:'',
        
      },
    ]);
    const [example, setexample] = useState([
      {
        natureOfGoods: '',       // Nature of Goods input
    productDescription: '', 
  },
]);
const translations = {
  "Nature of Goods": "طبيعة البضائع",

  
  "Manpower":"قوى عاملة",
  "manpower":"قوى عاملة",
  "Kingdom of Saudi Arabia": "المملكة العربية السعودية",
  "Saudi Arabia": "المملكة العربية السعودية",
  "Kindom of Saudi Arabia": "المملكة العربية السعودية",
  "KSA": "المملكة العربية السعودية",
};

// Function to handle translation
function translate(text) {
// Normalize input by converting to lowercase
// Normalize input: convert to lowercase and trim spaces
const normalizedText = text.toLowerCase().trim();

// Find the translation by comparing normalized and trimmed keys
const foundTranslation = Object.keys(translations).find(
key => key.toLowerCase().trim() === normalizedText
);


// Return the translated value or the original text if not found
return foundTranslation ? translations[foundTranslation] : text;
};
    
    // Helper function to calculate the amounts for each product
    const calculateProductAmounts = (unitRate, quantity, vatRate) => {
      const totalExclVAT = (parseFloat(unitRate) || 0) * (parseFloat(quantity) || 0);
      const vatAmount = (totalExclVAT * (parseFloat(vatRate) || 0)) / 100;
      const totalInclVAT = totalExclVAT + vatAmount;
      return {
        totalExclVAT,
        vatAmount,
        totalInclVAT,
      };
    };
    const handleInputChange = (e, section) => {
      const { name, value } = e.target;
      if (section === 'client') {
        setClientDetails({ ...clientDetails, [name]: value });
      } else if (section === 'invoice') {
        setInvoiceDetails({ ...invoiceDetails, [name]: value });
      } };
    // Handle input change for products
    const handleProductChange = async(e, index) => {
      debugger
      const { name, value } = e.target;
      const updatedProducts = [...products];
      
      updatedProducts[index][name] = value;
  
      // Calculate the totals after the input change
      const { totalExclVAT, vatAmount, totalInclVAT } = calculateProductAmounts(
        updatedProducts[index].unitRate,
        updatedProducts[index].quantity,
        updatedProducts[index].vatRate
      );
  
      // Update the product with calculated amounts
      updatedProducts[index].totalExclVAT = totalExclVAT.toFixed(2);
      updatedProducts[index].vatAmount = vatAmount.toFixed(2);
      updatedProducts[index].totalInclVAT = totalInclVAT.toFixed(2);
  // Update the translated text based on the input
 
  setexample((prevProduct) => ({
    ...prevProduct,
    [name]: value,
  }));     // Update the state with the translated value
        setProducts(updatedProducts);
      
    };
  
    // Add a new product row
    const addProductRow = () => {
      setProducts((prevProducts) => [
        ...prevProducts,
        { natureOfGoods: '', unitRate: '', quantity: '', vatRate: '15.00', totalExclVAT: 0, vatAmount: 0, totalInclVAT: 0 },
      ]);
    };
  
    // Remove a product row
    const removeProductRow = (index) => {
      const updatedProducts = products.filter((_, i) => i !== index);
      setProducts(updatedProducts);
    };
  
    // Helper functions to calculate totals for all products
    const calculateTotalExclVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.totalExclVAT || 0), 0).toFixed(2);
    };
  
    const calculateTotalVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.vatAmount || 0), 0).toFixed(2);
    };
  
    const calculateTotalInclVAT = () => {
      return products.reduce((acc, product) => acc + parseFloat(product.totalInclVAT || 0), 0).toFixed(2);
    };
  
    const calculateBalanceDue = () => {
      return calculateTotalInclVAT(); // Assuming balance due is total including VAT
    };

   
  const generateTLV = (tag, value) => {
    const tagHex = tag.toString(16).padStart(2, '0');
    const lengthHex = value.length.toString(16).padStart(2, '0');
    const valueHex = Buffer.from(value).toString('hex');
    return tagHex + lengthHex + valueHex;
  };

  const getBillDetailsForQRCode = () => {
    const sellerName = "LAR Contracting Company";
    const vatRegistrationNumber = "314702232800003";
    const invoiceDate = invoiceDetails.invoiceDate || '';

    const totalAmount = products
      .reduce((acc, product) => acc + (parseFloat(product.totalInclVAT) || 0), 0)
      .toFixed(2);
    const vatAmount = products
      .reduce((acc, product) => acc + (parseFloat(product.vatAmount) || 0), 0)
      .toFixed(2);

    const tlvEncoded =
      generateTLV(1, sellerName) +
      generateTLV(2, vatRegistrationNumber) +
      generateTLV(3, invoiceDate) +
      generateTLV(4, totalAmount) +
      generateTLV(5, vatAmount);

    return Buffer.from(tlvEncoded, 'hex').toString('base64');
  };


    // Transliterate Latin to Arabic
    const transliterateToArabic = (text) => {
      if (!text || typeof text !== 'string') {
        return ''; // Return an empty string if text is undefined, null, or not a string
      }

      const transliterationMap = {
          'a': 'ا', 'b': 'ب', 'c': 'ك', 'd': 'د', 'e': 'ي', 'f': 'ف',
          'g': 'ج', 'h': 'ه', 'i': 'ي', 'j': 'ج', 'k': 'ك', 'l': 'ل',
          'm': 'م', 'n': 'ن', 'o': 'و', 'p': 'ب', 'q': 'ق', 'r': 'ر',
          's': 'س', 't': 'ت', 'u': 'و', 'v': 'ف', 'w': 'و', 'x': 'كس',
          'y': 'ي', 'z': 'ز',

          'A': 'ا', 'B': 'ب', 'C': 'ك', 'D': 'د', 'E': 'ي', 'F': 'ف',
          'G': 'ج', 'H': 'ه', 'I': 'ي', 'J': 'ج', 'K': 'ك', 'L': 'ل',
          'M': 'م', 'N': 'ن', 'O': 'و', 'P': 'ب', 'Q': 'ق', 'R': 'ر',
          'S': 'س', 'T': 'ت', 'U': 'و', 'V': 'ف', 'W': 'و', 'X': 'كس',
          'Y': 'ي', 'Z': 'ز',

          ' ': ' ', ',': '،', '.': '.',
      };

      return Array.from(text).map(char => transliterationMap[char] || char).join('');
  };
  
    
 /* // Helper function to convert numbers to words
function numberToWords(num) {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (num === 0) return 'Zero';
  if (num < 20) return a[num];
  if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
  if (num < 1000) return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + numberToWords(num % 100) : '');
  return num.toString(); // For larger numbers, extend this logic as needed
}
*/
const printInvoice = async () => {
  const translatedGoods = transliterateToArabic(example.natureOfGoods);
  const amountWordsArabic = {
    zero: 'صفر',
    one: 'واحد',
    two: 'اثنان',
    three: 'ثلاثة',
    four: 'أربعة',
    five: 'خمسة',
    six: 'ستة',
    seven: 'سبعة',
    eight: 'ثمانية',
    nine: 'تسعة',
    ten: 'عشرة',
    eleven: 'أحد عشر',
    twelve: 'اثنا عشر',
    thirteen: 'ثلاثة عشر',
    fourteen: 'أربعة عشر',
    fifteen: 'خمسة عشر',
    sixteen: 'ستة عشر',
    seventeen: 'سبعة عشر',
    eighteen: 'ثمانية عشر',
    nineteen: 'تسعة عشر',
    twenty: 'عشرون',
    thirty: 'ثلاثون',
    forty: 'أربعون',
    fifty: 'خمسون',
    sixty: 'ستون',
    seventy: 'سبعون',
    eighty: 'ثمانون',
    ninety: 'تسعون',
    hundred: 'مائة',
    thousand: 'ألف',
    million: 'مليون',
    billion: 'مليار',
    and: 'و',
    only: 'فقط',
    saudi: 'سعودي',
    riyal: 'ريال',
    riyals: 'ريالات',
    halala: 'هللة',
    halalas: 'هللات',
    halalah: 'هللة',
    halalahs: 'هللات'
  };
  const translatedDescription = String(example.productDescription || '').replace(
    /[A-Za-z]+|[^A-Za-z]+/g,
    (part) => amountWordsArabic[part.toLowerCase()]
      || (/^[A-Za-z]+$/.test(part) ? transliterateToArabic(part) : part)
  );
  const qrCodeMarkup = invoiceQrRef.current?.innerHTML;
  if (!qrCodeMarkup) {
    console.error('VAT Invoice QR code is not available for printing.');
    alert('Could not prepare the invoice QR code. Please try again.');
    return;
  }

  const printWindow = window.open('', '', 'height=600,width=800');
  if (!printWindow) {
    alert('The print window was blocked. Please allow pop-ups and try again.');
    return;
  }
  printWindow.document.write(`
    <html>
      <head>
        <title>Vat Invoice</title>
        <style>
     body {
         font-family: Arial, sans-serif;
         margin: 20px;
         padding: 20px;
     }
     table {
         width: 100%;
         max-width: 900px;
         border-collapse: collapse;
         margin-top: 20px;
         border: 1px solid #d8d2cc;
         margin-left: auto;
         margin-right: auto;
     }
     th, td {
         border: 1px solid #d8d2cc;
         padding: 6px;
         text-align: left;
         height: 20px; 
         line-height: 1; /* Adjust line height if needed */
     }
     th {
         background-color: #f3f0eb;
     }
     .Invoice {
         text-align: center;
         color: #1D2A5F;
         font-size: 20px;
         font-weight: 700;
         padding: 12px 0;
     }
     
     .invoice-title {
         text-align: center;
         font-size: 1.5rem;
         margin-bottom: 10px;
     }
     .bold {
         font-weight: bold;
     }
     .no-border {
         border: none;
     }
     .col1 {
         height: 40px;
         text-align: center;
     }
     .col2 {
         width: 140px; 
     }
     .col3 {
         height: 90px;
         text-align: center;
     }
     .col4 {
         width: 20%; 
     }
     .col5 {
         width: 24%; 
     }
     .col6 {
         width: 7%;
         text-align: center; 
     }
     .col7 {
         width: 23%; 
     }
     .col8 {
         width: 8%; 
     }
     .col9 {
         height: 30px;
     }
     .col10 {
         height: 30px;
         text-align: center;
     }
     .colgoods {
         width: 31%; 
     }
     .colQty {
         width: 4%;
         text-align: center; 
     }
     .collast{
         width: 20%;
     }
     .header-container {
         display: flex;
         justify-content: center;
         align-items: center;
         gap: 20px; /* Space between heading and logo */
     }
     .logo-container img {
         max-width: 100px; /* Adjust width as needed */
         height: auto;
     }
     .left-align {
         float: left;
     }
     .right-align {
         float: right;
         text-align: right; /* Ensures text is aligned to the right */
     }
     .clearfix::after {
         content: "";
         display: table;
         clear: both;
     }
     .Headtitle td {
         padding: 4px; 
         background-color: #1D2A5F;
     }

     .Headtitle h3 {
         margin: 0; 
         padding: 3px; 
         line-height: 1.2; 
         color: white;
     }
     p {
         margin: 0; 
     }
     .signature-section {
         text-align: center;
         vertical-align: bottom;
         padding-bottom: 10px;
     }
     .signature-section td {
         height: 60px;
     }
     .new{
         color: white;
         text-align: center; 
         background-color: #1D2A5F;
     }
     .qr-section {
         width: 20%;
         text-align: center;
         vertical-align: middle;
         border-left: 2px solid black;
     }
     .text-section {
         width: 30%;
         text-align: center;
         vertical-align: middle;
         border-left: 2px solid black;
     }
     
     .bold {
         font-weight: bold;
     }
     .arabic {
         font-size: 12px;
         display: block;
         font-family: 'Arial', sans-serif;
     }
     .align-end {
     text-align: right; /* Aligns text to the right */
     direction: rtl; /* Sets text direction to RTL */
 }
 @media print {
     * {
         -webkit-print-color-adjust: exact; 
         color-adjust: exact;               
         print-color-adjust: exact;         
     }
     body {
         margin: 0;
         padding: 0;
     }
 }
 </style>
</head>
<body>
 <div class="header-container">
     <div style="text-align: right;">
       <h1 style="color: #1D2A5F;">LAR Contracting Company</h1>
     </div>
     <div class="logo-container">
       <img src=${bill} alt="Logo Image" /> 
   </div>
 </div>
 <div>
     <p class="Invoice"><strong>Vat Invoice:</strong></br><span class="bold">فاتورة ضريبة القيمة المضافة</span></p>
     <div class="clearfix">
         <p class="left-align" style="color: #D55C36;"><strong>Invoice No:</strong> <span class="bold">${invoiceNumber}</span></p>
         <p class="right-align" style="color: #D55C36;"><strong>رقم الفاتورة:</strong> <span class="bold">${invoiceNumber}</span></p>
     </div>
 </div>

 <table class="Detail">
        <tr class="Headtitle">
            <td colspan="8">
                <div class="clearfix">
                <h3 class="left-align"><strong><u>Our Details:</u></strong></h3>
                <h3 class="right-align" "dir="rtl"><strong><u>تفاصيلنا:</u></strong></h3>
                </div>
            </td>
        </tr>
       <tr>
    <th class="col2">Name:</th>
    <td colspan="3" class="col2">LAR Contracting Company</td>
    <td colspan="3" class="col2" style="text-align: end;">شركة إل آر كونتراكتنج</td>
    <th class="col2 align-end">الاسم:</th>
</tr>
<tr>
    <th class="col2">Short Address:</th>
    <td colspan="3" class="col2">ENAA8599</td>
    <td colspan="3" class="col2" style="text-align: end;">ENAA8599</td>
    <th class="col2 align-end">العنوان المختصر:</th>
</tr>
<tr>
    <th class="col2">Secondary No:</th>
    <td colspan="3" class="col2">2287</td>
    <td colspan="3" class="col2"  style="text-align: end;">2287</td> 
    <th class="col2 align-end">صندوق البريد:</th>
</tr>
        <tr>
            <th class="col2">Building No:</th>
            <td class="col2">8599</td>
            <th class="col2">City:</th>
            <td> Prince Saud Ibn Abdullah Ibn Jalawi Branch, AL JUBAIL</td>
           <td  style="text-align: end;" >فرع الأمير سعود بن عبدالله بن جلوي</td>
            <th class="col2 align-end">المدينة:</th>
            <td style="text-align: end;">الجبيل</td>
            <th class="col2 align-end">رقم المبنى:</th>
        </tr>
        <tr>
            <th class="col2">Customer Account:</th>
            <td>31335115107</td>
            <th class="col2">District:</th>
            <td>Tebah Dist.</td>
            <td style="text-align: end;">حي طيبة</td>
            <th class="col2 align-end"> الحي:</th>
            <td style="text-align: end;">31335115107</td>
            <th class="col2 align-end">رقم حساب العميل:</th>
        </tr>
            <tr>
            <th class="col2">Postal Code:</th>
            <td>35513</td>
            <th class="col2">Country:</th>
            <td>Kingdom of Saudi Arabia</td>
            <td style="text-align: end; width:10%;">المملكة العربية السعودية</td>
            <th class="col2 align-end"> الدولة:</th>
            <td style="text-align: end;">35513</td>
            <th class="col2 align-end">الرمز البريدي:</th>
        </tr>
        <tr>
            <th class="col2">Vat Number:</th>
            <td>314702232800003</td>
            <th class="col2">CRN:</th>
            
            <td colspan="2" style="text-align:center;">7053932963</td>
            <th class="col2 align-end"> السجل التجاري:</th>
            <td style="text-align: end;">314702232800003</td>
            <th class="col2 align-end">رقم ضريبة القيمة المضافة:</th>
        </tr>
    </table>




 
 <table class="Detail">
     <tr class="Headtitle">
         <td colspan="8" class="col2">
             <div class="clearfix">
             <h3 class="left-align"><strong><u>Client Details:</u></strong></h3>
             <h3 class="right-align" dir="rtl"><strong><u>تفاصيل العميل:</u></strong></h3>
             </div>
         </td>
     </tr>
     <tr>
         <th class="col2">Name:</th>
         <td colspan="3" class="col2">${clientDetails.clientName}</td>
         <td colspan="3" class="col2"  style="text-align: end;"> ${transliterateToArabic(clientDetails.clientName)}</td>
         <th class="col2 align-end">اسم:</th>
     </tr>
     <tr>
         <th class="col9">Address:</th>
         <td colspan="3" class="col9"> ${clientDetails.clientAddress}</td>
         <td colspan="3" class="col9"  style="text-align: end;"> ${transliterateToArabic(clientDetails.clientAddress)}</td> 
         <th class="col9 align-end">عنوان:</th>
     </tr>
    <tr>
         <th class="col2">Addl. No:</th>
         <td>${clientDetails.clientAddNo}</td>
         <th class="col2">District:</th>
         <td style="width : 10%;">${clientDetails.clientDistrict}</td>
         <td  style="text-align: end; width : 10%;">${transliterateToArabic(clientDetails.clientDistrict)}</td>
         <th class="col2 align-end">الحي:</th>
         <td  style="text-align: end;">${clientDetails.clientAddNo}</td>
         <th class="col2 align-end">الرقم الإضافي:</th>
     </tr>
     <tr>
         <th class="col2">Postal Code:</th>
         <td>${clientDetails.clientPostalCode}</td>
         <th class="col2">Country:</th>
         <td> ${clientDetails.clientCountry}</td>
         <td  style="text-align: end;">${translate(clientDetails.clientCountry)}</td>
         <th class="col2 align-end">دولة:</th>
         <td  style="text-align: end;">${transliterateToArabic(clientDetails.clientPostalCode)}</td>
         <th class="col2 align-end">الرمز البريدي:</th>
     </tr>
   <tr>
         <th class="col2">Vat Number:</th>
         <td>${clientDetails.clientVatNumber}</td>
         <th class="col2">CRN:</th>
         <td colspan="2" style="text-align:center;">${clientDetails.clientCRN}</td>
         <th class="col2 align-end">السجل التجاري:</th>
         <td  style="text-align: end;">${clientDetails.clientVatNumber}</td>
         <th class="col2 align-end">رقم ضريبة القيمة المضافة: </th>
     </tr>

 <table class="Detail">
     <tr>
         <th class="col1">  تاريخ الفاتورة <br>Invoice Date</th>
         
         <th class="col1">تاريخ التوريد <br>Supply Date</th>
         
         <th class="col1">   رقم العقد / أمر الشراء  <br>Contract/PO No</th>
        
         <th class="col1">  فترة الفاتورة <br>Invoice Period</th>
        
         <th class="col1"> رقم المشروع / المرجع  <br>Project/Reference No</th>
        
     </tr>
     <tr>
        <td class="col2" style="text-align: center;">
  ${invoiceDetails.invoiceDate ? new Date(invoiceDetails.invoiceDate).toLocaleDateString('en-GB') : ''}
</td>
<td class="col2" style="text-align: center;">
  ${invoiceDetails.supplyDate ? new Date(invoiceDetails.supplyDate).toLocaleDateString('en-GB') : ''}
</td>

         <td class="col2" style="text-align: center;">${invoiceDetails.contractNo}</td>
         <td class="col2" style="text-align: center;">${invoiceDetails.invoicePeriod}</td>
         <td class="col2" style="text-align: center;">${invoiceDetails.projectRefNo}</td>
     </tr>
 </table>

 <table class="Detail">
<thead>
 <tr>
   <th class="col3"> الإجمالي شامل الضريبة (ريال سعودي) <br>Total Incl. VAT (SAR):</th>
   <th class="col3"> مبلغ ضريبة القيمة المضافة (ريال سعودي) <br>VAT Amount (SAR):</th>
   <th class="col6"> نسبة الضريبة (%) <br>VAT %:</th>
   <th class="col3"> الإجمالي بدون ضريبة (ريال سعودي) <br>Total Excl. VAT (SAR):</th>
   <th class="col3"> سعر الوحدة (ريال سعودي)<br>Unit Rate (SAR):</th>
   <th class="col6"> الكمية <br>Qty <br> /Hours:</th>
   <th class="col3"> وحدة <br>Unit/Hour:</th>
   <th class="colgoods" style="text-align: center;"> طبيعة السلع/الخدمات <br>Nature of Goods/Services:(Description)</th>
   
   <th class="col6">#</th>
 </tr>
</thead>
<tbody>
 ${products.map((product, index) => `
   <tr>
     <td class="col1">${product.totalInclVAT}</td>
     <td class="col1">${product.vatAmount}</td>
     <td class="col1">${product.vatRate}</td>
     <td class="col1">${product.totalExclVAT}</td>
     <td class="col1">${product.unitRate}</td>
     <td class="col1">${product.quantity}</td>
     <td class="col1">${product.unit}</td>
     <td class="col1" id="translatedNatureOfGoods">
       ${product.natureOfGoods} /${translatedGoods}
      </td>
      <td class="col1">${index + 1}</td>
   </tr>
 `).join('')}
</tbody>
</table>

<!-- Summary Section -->
<table class="Summary">
<tr>
 <td class="col4">Total Excl. VAT (SAR):</td>
 <td class="col8">${calculateTotalExclVAT(products)}</td>
 <td class="col5">الإجمالي بدون ضريبة (ريال سعودي)</td>
 <td colspan="4" rowspan="2" class="text-section">
 <div dir="ltr">${example.productDescription}</div>

         </td>
</tr>
<tr>
 <td class="col4">VAT Amount (SAR):</td>
 <td class="col8">${calculateTotalVAT(products)}</td>
 <td class="col5">مبلغ ضريبة القيمة المضافة (ريال سعودي)</td>
</tr>
<tr>
 <td class="col4">Total Incl. VAT (SAR):</td>
 <td class="col8">${calculateTotalInclVAT(products)}</td>
 <td class="col5">الإجمالي شامل الضريبة (ريال سعودي)</td>
 <td colspan="3" rowspan="2" class="signature-section">
         <div class="arabic" dir="rtl">${translatedDescription}</div>
         </td>
</tr>
<tr>
 <td class="col4">Balance Due (SAR):</td>
 <td class="col8">${calculateBalanceDue(products)}</td>
 <td class="col5">الرصيد المستحق (ر.س)</td>
</tr>
</table>
 

 <table>
     <tr>
         <th colspan="4" class="new">Bank Details / التفاصيل المصرفية</th>
         <th colspan="2" class="new">Prepared By / معد الفاتورة</th>
         <th colspan="2" class="new">Received By / مستلم الفاتورة</th>
         <td rowspan="6" class="qr-section">
             <!-- QR Code Frame -->
             <div id="qrcode">${qrCodeMarkup}</div>
             
         </td>
     </tr>
     <tr>
         <td colspan="2"><strong>ACCOUNT NAME</strong> / اسم الحساب</td>
         <td colspan="2" class="collast" >LAR Contracting Company<br>شركة إل آر كونتراكتنج</td>
         <td rowspan="5" class="signature-section" style="height:140px;padding:0;">
            <img src="${stamp}" alt="Signature with stamp" style="width:100%;height:140px;object-fit:fill;display:block;" />
         </td>
         <td colspan="3" rowspan="5" class="signature-section"><span class="arabic">&nbsp;</span></td>
     </tr>
     <tr>
         <td colspan="2"><strong>BANK</strong> / بنك</td>
         <td colspan="2" class="collast">Al Rajhi Bank</td>
     </tr>
     <tr>
         <td colspan="2"><strong>ACCOUNT</strong> / الحساب</td>
         <td colspan="2" class="collast">51300-001-0006085423395</td>
     </tr>
     <tr>
         <td colspan="2"><strong>IBAN</strong> / ايبان</td>
         <td colspan="2" class="collast">SA5380000513608015423395</td>
         
     </tr>
     <tr>
         <td colspan="2"><strong></strong> </td>
         <td colspan="2" class="collast"></td>
     </tr>
 </table>
       </body>
     </html>
 

 
   `);
   printWindow.document.close();
   if (!(await printWhenReady(printWindow))) return;
   const newInvoiceNumber = invoiceNumber + 1;
   setInvoiceNumber(newInvoiceNumber);
   localStorage.setItem('invoiceNumber', newInvoiceNumber);
      };
   
// Load the last invoice number from localStorage when the component mounts
useEffect(() => {
  const fetchNextInvoiceNumber = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/invoice/next-invoice-number`);
      if (response.status === 200) {
        const nextInvoiceNumber = Number(response.data.nextInvoiceNumber);
        setInvoiceNumber(Number.isFinite(nextInvoiceNumber) && nextInvoiceNumber >= DEMOUNIT_INVOICE_START
          ? nextInvoiceNumber
          : DEMOUNIT_INVOICE_START);
      } else {
        console.error('Failed to fetch invoice number:', response);
        setInvoiceNumber(DEMOUNIT_INVOICE_START);
      }
    } catch (error) {
      console.error('Error fetching next invoice number:', error);
      setInvoiceNumber(DEMOUNIT_INVOICE_START);
    } finally {
      setLoading(false);
    }
  };

  fetchNextInvoiceNumber();
}, []);

const handleSubmit = async () => {
  if (!invoiceNumber || isNaN(invoiceNumber)) {
    alert('Invoice number is invalid. Please refresh the page.');
    return;
  }

  const payload = {
    invoiceNumber,
    clientDetails,
    invoiceDetails,
    products: products.map((product, index) => ({
      natureOfGoods: product.natureOfGoods,
      unitRate: product.unitRate,
      quantity: product.quantity,
      vatRate: product.vatRate,
      totalExclVAT: product.totalExclVAT,
      vatAmount: product.vatAmount,
      totalInclVAT: product.totalInclVAT,
      unit: product.unit, // Include Unit/Hour
      productDescription: index === 0 ? example.productDescription : product.productDescription,
    })),
    totals: {
      totalExclVAT: calculateTotalExclVAT(),
      totalVAT: calculateTotalVAT(),
      totalInclVAT: calculateTotalInclVAT(),
      balanceDue: calculateBalanceDue(),
    },
  };

  try {
    const response = await axios.post(`${API_BASE_URL}/invoice`, payload);
    if (response.status === 201) {
      alert('Invoice submitted successfully!');
    } else {
      alert('Failed to submit invoice.');
    }
  } catch (error) {
    console.error('Error submitting invoice:', error);
    alert(error.response?.data?.error || 'An error occurred while submitting the invoice.');
  }
};

      
  const brandTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#0B1F3A',
        dark: '#061426',
        light: '#173D68',
        contrastText: '#FFFFFF'
      },
      secondary: {
        main: '#E85D3F',
        dark: '#C9432B',
        light: '#FF9A78',
        contrastText: '#0B1F3A'
      },
      success: { main: '#16845B' },
      error: { main: '#C0392B' },
      background: {
        default: '#F4F7FB',
        paper: '#FFFFFF'
      },
      text: {
        primary: '#172033',
        secondary: '#667085'
      }
    },
    typography: {
      fontFamily: 'Inter, "Segoe UI", Arial, sans-serif',
      h4: { fontWeight: 800 },
      h5: { fontWeight: 800 },
      h6: { fontWeight: 800 },
      button: { textTransform: 'none', fontWeight: 800 }
    },
    shape: { borderRadius: 14 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            margin: 0,
            background: '#F4F7FB'
          },
          '*': { boxSizing: 'border-box' }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: 'none' }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            minHeight: 42,
            borderRadius: 12,
            backgroundColor: '#FFFFFF',
            transition: 'all .2s ease',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#D8E0EA'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9EADC0'
            },
            '&.Mui-focused': {
              boxShadow: '0 0 0 4px rgba(232,93,63,.12)'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#E85D3F',
              borderWidth: 2
            }
          },
          input: {
            fontWeight: 600,
            fontSize: 14,
            color: '#172033'
          }
        }
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: '#667085',
            fontWeight: 600,
            '&.Mui-focused': { color: '#C9432B' }
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            minHeight: 42,
            borderRadius: 12,
            paddingInline: 16,
            boxShadow: 'none',
            transition: 'transform .18s ease, box-shadow .18s ease, background .18s ease',
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: '0 10px 22px rgba(11,31,58,.14)'
            }
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontWeight: 600,
            '&.Mui-selected': {
              backgroundColor: 'rgba(232,93,63,.10)'
            }
          }
        }
      }
    }
  });

  const sectionTitleSx = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    mb: 1.5,
    px: 1.5,
    py: 1.1,
    borderRadius: '12px 12px 12px 4px',
    color: '#FFFFFF',
    background: 'linear-gradient(135deg, #0B1F3A 0%, #173D68 100%)',
    boxShadow: '0 8px 22px rgba(11,31,58,.12)',
    overflow: 'hidden',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: 0,
      top: 0,
      width: 6,
      height: '100%',
      background: '#E85D3F'
    }
  };

  const fieldSx = {
    '& .MuiInputLabel-root': { fontSize: 13 },
    '& .MuiOutlinedInput-root': {
      height: 32,
      '& input': { padding: '3px 8px', fontSize: 14 },
      '& .MuiSelect-select': { padding: '3px 8px', fontSize: 14 }
    }
  };

  return (
    <ThemeProvider theme={brandTheme}>
      <div
        style={{
          direction: 'rtl',
          minHeight: '100vh',
          background: 'radial-gradient(circle at 10% 0%, rgba(232,93,63,.10), transparent 28%), linear-gradient(135deg, #EEF3F8 0%, #F8FAFC 52%, #EEF2F7 100%)',
          padding: '28px 14px 50px'
        }}
      >
        <DocumentNavigation />
        <Paper
          elevation={0}
          sx={{
            position: 'relative',
            mx: 'auto',
            maxWidth: 1220,
            overflow: 'hidden',
            borderRadius: { xs: 2.5, md: 4 },
            background: 'rgba(255,255,255,.96)',
            border: '1px solid rgba(11,31,58,.08)',
            boxShadow: '0 24px 70px rgba(11,31,58,.13)',
            backdropFilter: 'blur(12px)',
            '&::before': {
              content: '""',
              display: 'block',
              height: 5,
              background: 'linear-gradient(90deg, #0B1F3A 0%, #173D68 55%, #E85D3F 100%)'
            }
          }}
        >
          {/* HEADER */}
          <div
            style={{
              padding: '30px clamp(18px, 4vw, 42px) 26px',
              background: 'linear-gradient(135deg, #08192E 0%, #0B1F3A 55%, #173D68 100%)',
              color: '#fff',
              position: 'relative',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: 260,
                height: 260,
                borderRadius: '50%',
                background: 'rgba(232,93,63,.12)',
                left: -90,
                top: -140
              }}
            />
            <div
              style={{
                position: 'absolute',
                width: 180,
                height: 180,
                borderRadius: '50%',
                border: '1px solid rgba(255,255,255,.10)',
                right: 8,
                bottom: -120
              }}
            />

            <div
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 24,
                flexWrap: 'wrap'
              }}
            >
              <div style={{ textAlign: 'right', flex: '1 1 380px' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '6px 11px',
                    borderRadius: 999,
                    border: '1px solid rgba(232,93,63,.45)',
                    background: 'rgba(232,93,63,.10)',
                    color: '#FF9A78',
                    fontSize: 12,
                    fontWeight: 800,
                    letterSpacing: 1.1,
                    marginBottom: 10
                  }}
                >
                  LAR CONTRACTING • FINANCE
                </div>
                <Typography
                  variant="h4"
                  sx={{
                    color: '#FFFFFF',
                    fontWeight: 900,
                    letterSpacing: '-.5px',
                    lineHeight: 1.1
                  }}
                >
                  LAR Contracting Company
                </Typography>
                <Typography
                  sx={{
                    color: '#DDE6F0',
                    mt: 1,
                    fontWeight: 600,
                    fontSize: { xs: 13, sm: 15 }
                  }}
                >
                  VAT Invoice / فاتورة ضريبية
                </Typography>
                <div
                  style={{
                    width: 70,
                    height: 3,
                    borderRadius: 10,
                    background: '#E85D3F',
                    marginTop: 15,
                    marginRight: 0
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 190,
                  minHeight: 105,
                  padding: 12,
                  borderRadius: 18,
                  background: 'rgba(255,255,255,.09)',
                  border: '1px solid rgba(255,255,255,.14)',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <img
                  src={logo}
                  alt="LAR Contracting Company"
                  style={{
                    display: 'block',
                    width: 'min(100%, 230px)',
                    maxHeight: 82,
                    objectFit: 'contain'
                  }}
                />
              </div>
            </div>
          </div>

          <div style={{ padding: '28px clamp(16px, 4vw, 42px) 38px' }}>
            {/* INVOICE QUICK INFO */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
                gap: 12,
                marginBottom: 30
              }}
            >
              <div
                style={{
                  padding: '14px 16px',
                  borderRadius: 14,
                  background: '#F7F9FC',
                  border: '1px solid #E3E9F1'
                }}
              >
                <div style={{ color: '#667085', fontSize: 11, fontWeight: 800, marginBottom: 5 }}>
                  INVOICE NUMBER
                </div>
                <div style={{ color: '#0B1F3A', fontSize: 21, fontWeight: 900 }}>
                  {loading ? 'Loading...' : invoiceNumber || 26001}
                </div>
              </div>
              <div
                style={{
                  padding: '14px 16px',
                  borderRadius: 14,
                  background: 'linear-gradient(135deg, #FFF5F2, #FFFAF8)',
                  border: '1px solid #F3B5A6'
                }}
              >
                <div style={{ color: '#C9432B', fontSize: 11, fontWeight: 800, marginBottom: 5 }}>
                  DOCUMENT TYPE
                </div>
                <div style={{ color: '#0B1F3A', fontSize: 16, fontWeight: 900 }}>
                  VAT INVOICE • ضريبة القيمة المضافة
                </div>
              </div>
            </div>

            {/* OUR DETAILS */}
            <Typography variant="h6" align="right" sx={sectionTitleSx}>
              <span>Our Details</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#FF9A78' }}>تفاصيلنا</span>
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Name"
                  value={ourDetails.name}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  sx={fieldSx}
                />
              </Grid>

              {[
                ['Short Address', ourDetails.shortAddress],
                ['Secondary No', ourDetails.secondaryNo],
                ['Customer Account', ourDetails.addlNo],
                ['Building No', ourDetails.buildingNo],
                ['City', ourDetails.city],
                ['District', ourDetails.district],
                ['Country', ourDetails.country],
                ['Postal Code', ourDetails.postalCode],
                ['VAT Number', ourDetails.vatNumber],
                ['CRN', ourDetails.crn]
              ].map(([label, value], i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <TextField label={label} value={value} fullWidth InputProps={{ readOnly: true }} sx={fieldSx} />
                </Grid>
              ))}
            </Grid>

            {/* CLIENT DETAILS */}
            <Typography variant="h6" align="right" sx={{ ...sectionTitleSx, mt: 4 }}>
              <span>Client Details</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#FF9A78' }}>تفاصيل العميل</span>
            </Typography>

            <Grid container spacing={2}>
              {[
                ['Name', 'clientName'],
                ['Address', 'clientAddress'],
                ['District', 'clientDistrict'],
                ['Postal Code', 'clientPostalCode'],
                ['Country', 'clientCountry'],
                ['Addl. No', 'clientAddNo'],
                ['VAT Number', 'clientVatNumber'],
                ['CRN', 'clientCRN']
              ].map(([label, name]) => (
                <Grid item xs={12} sm={6} md={4} key={name}>
                  <TextField
                    label={label}
                    name={name}
                    value={clientDetails[name]}
                    onChange={(e) => handleInputChange(e, 'client')}
                    fullWidth
                    sx={fieldSx}
                  />
                </Grid>
              ))}
            </Grid>

            {/* INVOICE DETAILS */}
            <Typography variant="h6" align="right" sx={{ ...sectionTitleSx, mt: 4 }}>
              <span>Invoice Details</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#FF9A78' }}>تفاصيل الفاتورة</span>
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Invoice Number"
                  value={loading ? 'Loading...' : invoiceNumber || 26001}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  sx={fieldSx}
                />
              </Grid>

              {[
                ['Invoice Date', 'invoiceDate'],
                ['Supply Date', 'supplyDate']
              ].map(([label, name]) => (
                <Grid item xs={12} sm={6} md={4} key={name}>
                  <TextField
                    label={label}
                    type="date"
                    name={name}
                    value={invoiceDetails[name]}
                    onChange={(e) => handleInputChange(e, 'invoice')}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={fieldSx}
                  />
                </Grid>
              ))}

              {[
                ['Contract / PO No', 'contractNo'],
                ['Invoice Period', 'invoicePeriod'],
                ['Project / Reference No', 'projectRefNo']
              ].map(([label, name]) => (
                <Grid item xs={12} sm={6} md={4} key={name}>
                  <TextField
                    label={label}
                    name={name}
                    value={invoiceDetails[name]}
                    onChange={(e) => handleInputChange(e, 'invoice')}
                    fullWidth
                    sx={fieldSx}
                  />
                </Grid>
              ))}
            </Grid>

            {/* PRODUCTS */}
            <Typography variant="h6" align="right" sx={{ ...sectionTitleSx, mt: 4 }}>
              <span>Products / Services</span>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#FF9A78' }}>السلع / الخدمات</span>
            </Typography>

            {products.map((product, index) => (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  position: 'relative',
                  p: { xs: 1.8, sm: 2.5 },
                  mb: 2,
                  borderRadius: 3,
                  background: 'linear-gradient(145deg, #FFFFFF 0%, #F8FAFC 100%)',
                  border: '1px solid #E0E7EF',
                  boxShadow: '0 10px 28px rgba(11,31,58,.06)',
                  overflow: 'hidden',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 4,
                    height: '100%',
                    background: '#E85D3F'
                  }
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 10,
                    marginBottom: 16
                  }}
                >
                  <Typography sx={{ color: '#0B1F3A', fontWeight: 900, fontSize: 16 }}>
                    Product {index + 1}
                  </Typography>
                  <div
                    style={{
                      padding: '5px 10px',
                      borderRadius: 999,
                      background: '#EEF3F8',
                      color: '#526174',
                      fontSize: 11,
                      fontWeight: 800
                    }}
                  >
                    LINE ITEM {String(index + 1).padStart(2, '0')}
                  </div>
                </div>

                <Grid container spacing={2}>
                  {[
                    ['Nature of Goods', 'natureOfGoods'],
                    ['Unit Rate', 'unitRate'],
                    ['Quantity', 'quantity']
                  ].map(([label, name]) => (
                    <Grid item xs={12} sm={6} md={4} key={name}>
                      <TextField
                        label={label}
                        name={name}
                        type={name !== 'natureOfGoods' ? 'number' : 'text'}
                        value={product[name]}
                        onChange={(e) => handleProductChange(e, index)}
                        fullWidth
                        sx={fieldSx}
                      />
                    </Grid>
                  ))}

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      select
                      label="Unit"
                      name="unit"
                      value={product.unit}
                      onChange={(e) => handleProductChange(e, index)}
                      fullWidth
                      sx={fieldSx}
                    >
                      <MenuItem value="UNIT">UNIT</MenuItem>
                      <MenuItem value="HOURLY">HOURLY</MenuItem>
                      <MenuItem value="DAYS">DAYS</MenuItem>
                      <MenuItem value="METER">METER</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="VAT Rate"
                      name="vatRate"
                      type="number"
                      value={product.vatRate}
                      onChange={(e) => handleProductChange(e, index)}
                      fullWidth
                      sx={fieldSx}
                    />
                  </Grid>

                </Grid>

                <Grid container spacing={1.5} sx={{ mt: 1 }}>
                  {[
                    ['Excl. VAT', product.totalExclVAT, '#F4F7FB'],
                    ['VAT Amount', product.vatAmount, '#FFF5F2'],
                    ['Incl. VAT', product.totalInclVAT, '#EEF8F4']
                  ].map(([label, amount, bg]) => (
                    <Grid item xs={12} sm={4} key={label}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 1.5,
                          backgroundColor: bg,
                          borderRadius: 2,
                          border: '1px solid #E3E9F1',
                          color: '#0B1F3A'
                        }}
                      >
                        <Typography sx={{ color: '#667085', fontSize: 11, fontWeight: 800 }}>
                          {label}
                        </Typography>
                        <Typography sx={{ fontSize: 16, fontWeight: 900, mt: .3 }}>
                          {amount} SAR
                        </Typography>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>

                <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 16 }}>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => removeProductRow(index)}
                    sx={{
                      borderRadius: 2,
                      borderColor: 'rgba(192,57,43,.35)',
                      color: '#C0392B',
                      '&:hover': { borderColor: '#C0392B', background: 'rgba(192,57,43,.05)' }
                    }}
                  >
                    <DeleteIcon sx={{ mr: 0.7 }} />
                    Remove Item
                  </Button>
                </div>
              </Paper>
            ))}

            <Button
              variant="contained"
              onClick={addProductRow}
              sx={{
                mb: 3,
                background: 'linear-gradient(135deg, #E85D3F, #C9432B)',
                color: '#0B1F3A',
                '&:hover': { background: 'linear-gradient(135deg, #F06A45, #C9432B)' }
              }}
            >
              + Add Product / Service
            </Button>

            {/* TOTALS */}
            <Paper
              elevation={0}
              sx={{
                mt: 2,
                p: { xs: 2, sm: 3 },
                borderRadius: 3,
                background: 'linear-gradient(135deg, #08192E 0%, #0B1F3A 55%, #173D68 100%)',
                color: '#fff',
                position: 'relative',
                overflow: 'hidden',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  width: 180,
                  height: 180,
                  borderRadius: '50%',
                  border: '1px solid rgba(232,93,63,.18)',
                  right: -70,
                  top: -80
                }
              }}
            >
              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
                  <Typography variant="h6" sx={{ color: '#fff', fontWeight: 900 }}>
                    Invoice Summary
                  </Typography>
                  <Typography sx={{ color: '#FF9A78', fontSize: 13, fontWeight: 800 }}>
                    ملخص الفاتورة
                  </Typography>
                </div>

                <Grid container spacing={1.5}>
                  {[
                    ['Total Excl. VAT', calculateTotalExclVAT()],
                    ['Total VAT', calculateTotalVAT()],
                    ['Total Incl. VAT', calculateTotalInclVAT()],
                    ['Balance Due', calculateBalanceDue()]
                  ].map(([label, amount], i) => (
                    <Grid item xs={12} sm={6} md={3} key={label}>
                      <div
                        style={{
                          padding: 16,
                          minHeight: 92,
                          borderRadius: 14,
                          background: i === 3 ? 'linear-gradient(135deg, rgba(232,93,63,.28), rgba(232,93,63,.10))' : 'rgba(255,255,255,.075)',
                          border: i === 3 ? '1px solid rgba(232,93,63,.45)' : '1px solid rgba(255,255,255,.10)'
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#B9C6D5', fontSize: 11, fontWeight: 700 }}>
                          {label}
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 900, mt: .5, color: i === 3 ? '#FF9A78' : '#FFFFFF' }}>
                          {amount} SAR
                        </Typography>
                      </div>
                    </Grid>
                  ))}
                </Grid>
                <TextField
                  label="Final Amount In Words"
                  value={example.productDescription}
                  onChange={(e) => setexample((current) => ({
                    ...current,
                    productDescription: e.target.value
                  }))}
                  placeholder="Enter the final amount in words"
                  fullWidth
                  sx={{
                    mt: 2,
                    '& .MuiOutlinedInput-root': { height: 'auto', minHeight: 42, backgroundColor: '#FFFFFF' },
                    '& .MuiInputLabel-root': { fontSize: 14 }
                  }}
                />
              </div>
            </Paper>
            <Paper
              elevation={0}
              sx={{
                mt: 2,
                p: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap',
                borderRadius: 3,
                border: '1px solid #E0E7EF',
                backgroundColor: '#FFFFFF'
              }}
            >
              <div>
                <Typography sx={{ color: '#0B1F3A', fontWeight: 800 }}>
                  Invoice QR Code
                </Typography>
                <Typography variant="body2" sx={{ color: '#667085', mt: 0.5 }}>
                  Scan to view the invoice details.
                </Typography>
              </div>
              <div ref={invoiceQrRef} aria-label="Invoice QR code preview">
                <QRCodeSVG value={getBillDetailsForQRCode()} size={144} level="M" />
              </div>
            </Paper>

            {/* ACTIONS */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 12,
                flexWrap: 'wrap',
                marginTop: 28
              }}
            >
              <Button
                sx={{
                  minWidth: 140,
                  background: 'linear-gradient(135deg, #E85D3F, #C9432B)',
                  color: '#0B1F3A',
                  '&:hover': { background: 'linear-gradient(135deg, #F06A45, #C9432B)' }
                }}
                onClick={printInvoice}
              >
                Print Invoice
              </Button>
              <Button
                sx={{
                  minWidth: 140,
                  background: '#0B1F3A',
                  color: '#fff',
                  '&:hover': { background: '#061426' }
                }}
                onClick={handleSubmit}
              >
                Submit Invoice
              </Button>
              <Button
                sx={{
                  minWidth: 140,
                  background: '#EEF3F8',
                  color: '#0B1F3A',
                  border: '1px solid #D8E0EA',
                  '&:hover': { background: '#E3EAF2' }
                }}
                onClick={() =>
                  window.open('https://wa.me/919486042369?text=Hello, I need help', '_blank')
                }
              >
                WhatsApp Help
              </Button>
            </div>

            {/* CONTACT */}
            <div
              style={{
                marginTop: 34,
                padding: '18px 10px 4px',
                borderTop: '1px solid #E5EAF0',
                textAlign: 'center',
                direction: 'rtl'
              }}
            >
              <Typography variant="body2" sx={{ color: '#526174', fontWeight: 600, mb: .7 }}>
                الهاتف: <span dir="ltr" style={{ unicodeBidi: 'isolate' }}>057 2386 528 | 013 512 8496</span>
              </Typography>
              <Typography variant="body2" sx={{ color: '#526174', fontWeight: 600, mb: .7 }}>
                البريد الإلكتروني: info@larcontracting.com
              </Typography>
              <Typography variant="body2" sx={{ color: '#526174', fontWeight: 600 }}>
                الموقع الإلكتروني: www.larcontracting.com
              </Typography>
            </div>
          </div>
        </Paper>

      </div>
    </ThemeProvider>
  );

};

export default InvoiceGenerator;
